<template>
  <div class="news">
    <app-header action="search-news" />
    <main>
      <news-list :news-list="newsList" />
    </main>
    <app-footer />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { EventBus } from '../utils/EventBus.js'
  import moment from 'moment'
  import AppHeader from '../components/Header.component'
  import AppFooter from '../components/Footer.component'
  import NewsList from '../components/NewsList.component'

  export default {
    name: 'news',
    components: {
      AppHeader,
      AppFooter,
      NewsList
    },
    computed: {
      // Map Vuex state.
      ...mapState({
        newsList: state => {
          return state.News.newsList.map(news => ({
            ...news,
            images: news.images
              ? JSON.parse(news.images).map(image => encodeURI(image))
              : [],
            published_at: moment(news.published_at).locale('th').fromNow()
          }))
        },
        totalPage: state => {
          return state.News.lastPage
        },
        page: state => {
          return state.News.currentPage
        }
      })
    },

    created () {
      // Listen to scroll to end event.
      EventBus.$on('scroll-to-end', this.appendNewsList)
      return this.$store.dispatch('News/getNewsList')
    },

    destroyed () {
      EventBus.$off('scroll-to-end', this.appendNewsList)
    },

    methods: {
      appendNewsList () {
        console.log(this.totalPage)
        console.log(this.page)
        if (this.page < this.totalPage) {
          this.$store.dispatch(`News/getNewsList`, this.page + 1)
        }
      },
      toggleFollow (organizeId) {
        return this.$store.dispatch(`Organize/followOrganization`, organizeId)
          .then(() => this.$store.dispatch(`Organize/getOrganizeDetail`, this.organizationId))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  main {
    // Interpolation for SCSS variables to be in calc
    margin-top: calc(#{$header-height} + 15px);
    padding-bottom: 1px;
    .back-to-top {
      @extend .position-fixed;
      @extend .cursor-pointer;
      right: 20px;
      bottom: 40px;
      img {
        width: 34px;
        height: 34px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/News.page.vue